import { render, staticRenderFns } from "./PropertyModal.vue?vue&type=template&id=896ef5be&scoped=true&"
import script from "./PropertyModal.vue?vue&type=script&lang=js&"
export * from "./PropertyModal.vue?vue&type=script&lang=js&"
import style0 from "./PropertyModal.vue?vue&type=style&index=0&id=896ef5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ef5be",
  null
  
)

export default component.exports